import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from '../../services/api.service';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const loginGuard: CanActivateFn = () => {
  const api = inject(ApiService);
  const router = inject(Router);
  const cookieService = inject(CookieService);

  if (cookieService.get('must_change_password') === '1') {
    return of(true);
  }

  if (!cookieService.get('token')) {
    return of(true);
  }

  return api.checkLogin().pipe(
    map(() => {
      router.navigate(['/dashboard']);
      return false;
    }),
    catchError(() => {
      cookieService.delete('token', '/');
      cookieService.delete('user_id', '/');
      cookieService.delete('username', '/');
      cookieService.delete('name', '/');
      cookieService.delete('company_id', '/');
      cookieService.delete('must_change_password', '/');
      cookieService.deleteAll('/');
      return of(true);
    })
  );
};
